import {User} from "../domain/entities/user.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Entity command (ADR-015): changes the first and last name of the logged-in user. The payload is
 * the change-tracked `User` proxy, so the generic command path sends only the changed names plus
 * `uid` — no transformer. The backend accepts it only for the session user's own record.
 */
export class UpdateUserCommand extends AbstractCommand<User> {

    public name: CommandName = CommandName.UPDATE_USER;

    public tags = ['entity', 'update', 'user'];

    constructor(payload: User) {
        super('user', payload.uid, payload);
    }
}
